function Addresses({ label, items, roles, testid }) {
  return (
    <div className="flex gap-3 text-sm" data-testid={testid}>
      <span className="w-20 shrink-0 font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500 pt-1">{label}</span>
      <span className="flex flex-wrap gap-1.5">
        {items.length === 0 ? <span className="text-stone-400">nobody</span> : items.map((x) => (
          <span key={x.address} className="inline-flex items-center gap-1 rounded-full border border-stone-200 bg-white px-2.5 py-0.5 text-xs text-stone-700">
            {x.address}
            <span className="text-stone-400">· {x.via === "extra" ? "added" : roles[x.via]?.label || x.via}</span>
          </span>
        ))}
      </span>
    </div>
  );
}

export function EmailPreview({ preview, roles }) {
  if (!preview) return null;
  return (
    <div className="rounded-xl border border-stone-200 bg-white overflow-hidden" data-testid="sow-email-preview">
      <div className="px-5 py-4 border-b border-stone-200 flex flex-col gap-2 bg-stone-50/60">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500">Preview with sample data</p>
        <Addresses label="To" items={preview.to} roles={roles} testid="sow-email-preview-to" />
        <Addresses label="Cc" items={preview.cc} roles={roles} testid="sow-email-preview-cc" />
        <div className="flex gap-3 text-sm" data-testid="sow-email-preview-reply">
          <span className="w-20 shrink-0 font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500 pt-1">Reply-to</span>
          <span className="text-stone-700">{(Array.isArray(preview.reply_to) ? preview.reply_to.join(", ") : preview.reply_to) || <span className="text-stone-400">not set</span>}</span>
        </div>
        <div className="flex gap-3 text-sm" data-testid="sow-email-preview-subject">
          <span className="w-20 shrink-0 font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500 pt-1">Subject</span>
          <span className="text-stone-900 font-medium">{preview.high_importance && <span className="text-rose-600 mr-1" title="High importance">!</span>}{preview.subject}</span>
        </div>
      </div>
      <iframe title="Email preview" srcDoc={preview.html} sandbox="" className="w-full bg-[#f5f5f4]" style={{ height: "calc(100vh - 300px)", minHeight: 520 }} data-testid="sow-email-preview-frame" />
    </div>
  );
}
